import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forArray, (key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key,
      class: "seat",
      style: _normalizeStyle(_ctx.style)
    }, null, 4 /* STYLE */))
  }), 128 /* KEYED_FRAGMENT */))
}